<template>
  <div class="page flex-col">
    <div class="block_1 flex-col justify-end">
      <!-- <div class="block_2 flex-row">
        <img class="image_1" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng5eb7835fc957042f4b02048930b15033b02aadc08574d830df2c060761b9879a.png" />
        <img class="image_2" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng4b858c76b9deb5b3941827f27d1c8ac1b586ba98eec1392060201b04c690af4c.png" />
        <span class="text_1">自由随心·Al随行·慧安智远</span>
        <span class="text_2" @click="PageIndex">首页</span>
        <span class="text_3" @click="sdycxq">产品方案</span>
        <span class="text_4" @click="case_presentation">案例展示</span>
        <span class="text_5" @click="news_information">新闻动态</span>
        <span class="text_6" @click="guanyuhuian">关于慧安</span>
      </div> -->

      <div class="block_2 flex-row items-center"> <!-- 新增items-center确保垂直居中 -->
        <img class="image_1" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng5eb7835fc957042f4b02048930b15033b02aadc08574d830df2c060761b9879a.png" />
        <img class="image_2" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng4b858c76b9deb5b3941827f27d1c8ac1b586ba98eec1392060201b04c690af4c.png" />
        <span class="text_1">自由随心·Al随行·慧安智远</span>
        <span class="text_2" @click="PageIndex">首页</span>
        <!-- <span class="text_3" @click="sdycxq">产品方案</span> -->

        <div class="dropdown-container" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
          <span class="text_4 cursor-pointer">产品方案</span>
          <div class="dropdown-menu" v-if="showDropdown">
            <div class="dropdown-item" @click="handleCaseClick('three_narcotic_drug_vehicle')">三代麻精药品车</div>
            <div class="dropdown-item" @click="handleCaseClick('two_narcotic_drug_vehicle')">二代麻精药品车</div>
            <div class="dropdown-item" @click="handleCaseClick('consumables_cabinet')">高值耗材柜</div>
            <div class="dropdown-item" @click="handleCaseClick('ai_recycling_bin')">AI智能回收箱</div>
            <div class="dropdown-item" @click="handleCaseClick('hydrogenperoxide_disinfection_machine')">过氧化氢消毒机</div>
            <div class="dropdown-item" @click="handleCaseClick('transfer_bed')">电动转运床</div>

          </div>
        </div>

        <span class="text_4" @click="case_presentation">案例展示</span>



        <span class="text_5" @click="news_information">新闻动态</span>
        <span class="text_6" @click="guanyuhuian">关于慧安</span>
      </div>

      <div class="block_3 flex-row">
        <div class="section_1 flex-col"></div>
      </div>
    </div>
    <div class="block_4 flex-row">
      <div class="text-group_1 flex-col justify-between">
        <span class="paragraph_1">
          慧安智远致力于：
          <br />
          让世界上每一支管控药都
          <br />
          数得清、用的清、记得清
          <br />
        </span>
        <span class="text_7">欢迎来到慧安智远，自由随心·Al随行·慧安智远</span>
      </div>
      <div class="box_1 flex-col">
        <div class="image-wrapper_1 flex-col">
          <!-- <img
            class="image_3"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPngb6c5deffc1f311cdddd63e85d64e542d21b9e228f754e03b5ec3511637a632c6.png"
          /> -->
        </div>
      </div>
      <div class="image-wrapper_2 flex-col">
        <img class="image_4" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng3cf61ce395c74f98272ed55b67d3e840760e740b739b579e3bf524065a09a976.png" />
      </div>
    </div>
    <div class="block_5 flex-col">
      <div class="section_2 flex-col">
        <div class="group_1 flex-row">
          <div class="text-wrapper_1 flex-col"><span class="text_8">我们的核心服务</span></div>
        </div>
        <div class="text-wrapper_2 flex-row"><span class="text_9">麻精药品车</span></div>
        <div class="group_2 flex-row justify-between">
          <div class="box_2 flex-col">
            <span class="paragraph_2">
              麻精药品智能管理系统，采用一体化结构制造，双人双锁，完全符合国家管控药品储存要求。严格遵守“五专”制度：
              <br />
              专人负责：设置操作权限管理，密码或指纹登录，实时记录用户的使用情况
              <br />
              专柜加锁：按照品种管控原则，双重的电子锁定，针对用户的权限授权开放&nbsp;
              <br />
              专用账册：配置独立的数据库，信息化电子报表，系统真正实现无纸化办公
              <br />
              专用处方：接受处理HIS处方，自动生成请领单，按照处方信息提示发药&nbsp;
              <br />
              专册登记：专有电子台账系统，记录完整的信息，数据自动上传服务器备份
              <br />
              <br />
              <br />
              药车配置5层抽屉，除冷藏抽屉外，其他均可根据医院需求进行选配。最大载药量达到1200+。
              <br />
              设备支持接入HIS/手麻系统，能够根据手术取药，亦可开放式取药。麻醉医生根据取药记录进行空瓶回收，空安瓿瓶回收到个人回收盒中。红白处方也支持在药车上打印。
            </span>
            <div class="image-text_1 flex-row justify-between">
              <img class="label_1" referrerpolicy="no-referrer"
                src="./assets/img/SketchPng77ed9f1e1102bbd2722b7d573a002ed8e65b6e63b7642bb7cd8658d4166c29f6.png" />
              <span class="text-group_2">配置自定义</span>
            </div>
            <div class="image-text_2 flex-row justify-between">
              <img class="label_2" referrerpolicy="no-referrer"
                src="./assets/img/SketchPng77ed9f1e1102bbd2722b7d573a002ed8e65b6e63b7642bb7cd8658d4166c29f6.png" />
              <span class="text-group_3">多种存储方式</span>
            </div>
          </div>
          <div class="box_3 flex-col">
            <div class="image-wrapper_3 flex-col">
              <img class="image_5" referrerpolicy="no-referrer" src="./assets/img/mjypc.png" />
            </div>
          </div>
        </div>
        <div class="group_3 flex-row">
          <div class="image-text_3 flex-row justify-between">
            <img class="label_3" referrerpolicy="no-referrer"
              src="./assets/img/SketchPng77ed9f1e1102bbd2722b7d573a002ed8e65b6e63b7642bb7cd8658d4166c29f6.png" />
            <span class="text-group_4">体积小巧</span>
          </div>
        </div>
      </div>
      <div class="image-wrapper_4 flex-col">
        <img class="image_6" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng48e029494568d9c9a3cf3459738779b5a097820b014206c9e8176b2a4608e43c.png" />
      </div>
    </div>
    <div class="block_6 flex-col">
      <img class="image_7" referrerpolicy="no-referrer"
        src="./assets/img/SketchPng58feb21f9a5ede3d0286a9fbf605e4ce98141693780cb9b020cfaff4aa2d102a.png" />
      <div class="block_7 flex-col">
        <div class="box_4 flex-col">
          <div class="box_5 flex-col">
            <div class="block_8 flex-col">
              <div class="image-wrapper_5 flex-col">
                <!-- <img
                  class="image_8"
                  referrerpolicy="no-referrer"
                  src="./assets/img/SketchPngfce5ce21dc0390f82ab975b94c625bf5369060ce1850a747504cede7eb24f08a.png"
                /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="block_9 flex-col">
      <div class="text-wrapper_3 flex-row">
        <span class="text_10">公司信息</span>
        <span class="text_11">二维码</span>
        <span class="text_12">商务合作</span>
      </div>
      <div class="image-wrapper_6 flex-row justify-between">
        <img class="image_9" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng1c0a871b3fb97b29a5d07e5b71ab2c9223c1b2d4b7269d3443356771d6bdf9aa.png" />
        <img class="image_10" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng1c0a871b3fb97b29a5d07e5b71ab2c9223c1b2d4b7269d3443356771d6bdf9aa.png" />
        <img class="image_11" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng1c0a871b3fb97b29a5d07e5b71ab2c9223c1b2d4b7269d3443356771d6bdf9aa.png" />
      </div>
      <div class="section_3 flex-row">
        <span class="paragraph_3">
          江苏慧安智远智能医疗科技有限公司
          <br />
          <br />
          地址：无锡市惠山区惠山大道1719-5号二层B区&nbsp;
          <br />
          电话：0510-83582015
          <br />
          邮箱：huianzhiyuan&#64;qq.com
          <br />
          官网：www.hilears.com&nbsp;
          <br />
        </span>
        <div class="image-text_4 flex-col justify-between">
          <div class="image-wrapper_7 flex-col">
            <img class="image_12" referrerpolicy="no-referrer"
              src="./assets/img/SketchPng6d89f0dbceb8cf2835772a0f780d8d18a85d8ad63f161fa6700239ef2ee1b0b1.png" />
          </div>
          <span class="text-group_5">
            关注公众号：HILEARS和尔思
            <br />
          </span>
        </div>
        <span class="text_13">卢先生&nbsp;&nbsp;0510-83582015</span>
      </div>
      <div class="text-wrapper_4 flex-row">
        <span class="text_14">
          Copyright&nbsp;©&nbsp;&nbsp;2025&nbsp;-&nbsp;forever&nbsp;&nbsp;江苏慧安智远智能医疗科技有限公司所有
          <a onclick="window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32020602001022')">苏公网安备
            32020602001022号&nbsp;&nbsp;</a>
          <a onclick="window.open('https://beian.miit.gov.cn')">苏ICP备20031743号-1</a>

        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 新增下拉菜单控制变量
      showDropdown: false,
      constants: {}
    };
  },
  methods: {
    // 新增下拉菜单点击处理方法
    handleCaseClick(type) {
      // 根据不同案例类型跳转到不同页面
      this.$router.push(`/${type}`);
      // 关闭下拉菜单
      this.showDropdown = false;
    },
    PageIndex() {
      this.$router.push('/PageIndex')
    },
    sdycxq() {
      this.$router.push('/three_narcotic_drug_vehicle')
    },
    guanyuhuian() {
      this.$router.push('/guanyuhuian')
    },
    case_presentation() {
      this.$router.push('/case_presentation')
    },
    news_information() {
      this.$router.push('/news_information')
    },
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style>
/* 修改下拉菜单样式 */
.dropdown-container {
  position: relative;
  display: inline-flex;
  /* 使用inline-flex保持与其他元素对齐 */
  align-items: center;
  /* 确保文本垂直居中 */
  height: 50%;
  /* 占满父容器高度 */
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  /* 从容器底部开始显示 */
  left: 0;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  min-width: 160px;
  z-index: 1000;
  margin-top: 5px;
  /* 与主菜单保持一点距离 */
  padding: 8px 0;
  animation: fadeIn 0.2s ease-in-out;
}

/* 调整菜单项样式 */
.dropdown-item {
  padding: 10px 16px;
  color: #1d1f24;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

/* 修复父容器对齐 */
.box_1 {
  align-items: center;
  /* 确保所有子元素垂直居中 */
  display: flex;
}

/* 保持其他样式不变 */
.text_4 {
  /* 确保文本本身垂直居中 */
  display: inline-flex;
  align-items: center;
  height: 100%;
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
